import {
  Cell,
  Legend,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

const COLORS = [
  "#2563eb",
  "#16a34a",
  "#dc2626",
  "#7c3aed",
  "#ea580c",
  "#0891b2",
  "#ca8a04",
  "#4f46e5",
  "#0d9488",
  "#be123c",
];

const WarehouseChartView = ({ warehouses }) => {
  const data = (warehouses || [])
    .map((item) => ({
      name:
        item.warehouse_name ||
        (item.warehouse_id ? `Warehouse ${item.warehouse_id}` : "Unknown"),
      value: item.qty ?? 0,
    }))
    .sort((a, b) => b.value - a.value);

  if (data.length === 0) {
    return <div className="opacity-70 text-sm">No warehouse data.</div>;
  }

  return (
    <ResponsiveContainer width="100%" height={320}>
      <PieChart>
        <Pie
          data={data}
          dataKey="value"
          nameKey="name"
          cx="50%"
          cy="50%"
          outerRadius={110}
          label={({ percent }) => `${(percent * 100).toFixed(1)}%`}
        >
          {data.map((entry, index) => (
            <Cell
              key={`cell-${entry.name}`}
              fill={COLORS[index % COLORS.length]}
            />
          ))}
        </Pie>
        <Tooltip formatter={(value) => Number(value).toLocaleString()} />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  );
};

export default WarehouseChartView;
